package co.maytes.standupbot.dashboard.features.analytics

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.styles.Motion
import kotlinx.coroutines.delay

private const val INTRO_START_DELAY_MS = 50L

internal object ChartMotion {
    fun staggerMs(index: Int): Int = (index * Motion.STAGGER_STEP_MS).coerceAtMost(Motion.STAGGER_CAP_MS)

    fun intro(property: String, index: Int = 0): String {
        val delayMs = staggerMs(index)
        return "$property ${Motion.CHART_INTRO_MS - delayMs}ms ${Motion.EASE_EMPHASIS} ${delayMs}ms"
    }

    fun update(vararg properties: String): String =
        Motion.transition("${Motion.CHART_UPDATE_MS}ms", *properties)
}

@Composable
internal fun rememberChartIntroPlayed(): Boolean {
    var played by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        delay(INTRO_START_DELAY_MS)
        played = true
    }
    return played
}
